import { jsx as _jsx } from "react/jsx-runtime";
import { FileStatusPanelItem, FileStatusSubtitle, FileStatusTitle } from "@air/feature-file-status/ui";
import classNames from "classnames";
import { memo } from "react";
import { getSubtitleWithProgress } from "../../utils";
import { FileStatusThumbnail } from "./FileStatusThumbnail";
export const FileStatusTrackingPanelListItemCompleted = /*#__PURE__*/ memo((param)=>{
    let { item: { ext, onRowClick, previewLoader, avatar, title, thumbnailSource, sizeInBytes, subtitle, status } } = param;
    return /*#__PURE__*/ _jsx(FileStatusPanelItem, {
        onClick: onRowClick,
        className: classNames("mx-1.5 rounded px-2.5 py-1.5 opacity-60 transition-all duration-200", !!onRowClick && "cursor-pointer hover:bg-grey-3"),
        previewLoader: previewLoader,
        avatar: avatar !== null && avatar !== void 0 ? avatar : /*#__PURE__*/ _jsx(FileStatusThumbnail, {
            ext: ext,
            status: status,
            thumbnailSource: thumbnailSource
        }),
        title: /*#__PURE__*/ _jsx(FileStatusTitle, {
            children: title
        }),
        subtitle: /*#__PURE__*/ _jsx(FileStatusSubtitle, {
            className: "truncate",
            children: subtitle !== null && subtitle !== void 0 ? subtitle : getSubtitleWithProgress({
                title: "Completed",
                uploadedBytes: sizeInBytes,
                sizeInBytes
            })
        }),
        buttons: null
    });
});
FileStatusTrackingPanelListItemCompleted.displayName = "FileStatusTrackingPanelListItemCompleted";
